module.exports = __webpack_public_path__ + "static/media/logo-cell.94e7d773.svg";